import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import SET_USER from './types';
export default _defineProperty({}, SET_USER, function (state, payload) {
  var currentState = state;
  currentState.user = payload;
});